module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABEUlEQVQ4T+3UvyuFcRTH8dcZDJJJMShKYWEUpZRNuUZ/BJPF/3EX7up/QNnUHWRWBoqilMlIoY4eIZ77PHFl9B3Pj/f3nM85nVDxMrMXC+gpuZ/QjoiHclrUgHbRqPJhLyJWfgo6Qysimp8TMnMDaxEx2QHKzBaGS45FXOGyZB/DKA5L9pvIzMQBrmta+c48gqV3UCMi9r/LqNFz+VW3t4o20YyI525gmVkMaw1b76Ad9OEeRzjBeUTcZeZ6AY+I7czsxzimMI9BFCux+qW1zCxgs5jGBAYwh0LHNor9ucApjt8++tJarUafK/qJRn8m9j+oU+7M/JjaY8W56GYvi9inYo9mMNRtZin+tvIe/Qb6AhrLnKOxkGtxAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/images/product/xiaoshou_tab.png
// module id = JelW
// module chunks = 1